import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ExtractBlogInstructionsFromUrl($sectionId: ID!, $url: String!, $projectId: ID) {
    extractBlogInstructionsFromUrl(sectionId: $sectionId, url: $url, projectId: $projectId) {
      instructions
      status
      extractionErrors
    }
  }
`;

interface Result {
  instructions: string;
  status: string;
  extractionErrors: string[] | null;
}

export const extractBlogInstructionsFromUrl = async (sectionId: ID, url: string, projectId: ID) => {
  const variables = { sectionId, url, projectId };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });

  return getSingleProp<Result>(result.data);
};
